import { ReactElement, ReactNode } from 'react'
import { AuthService } from './AuthService'
import { AuthContext } from './AuthContext'

interface AuthProviderProps {
  children: ReactNode
  authService: AuthService
}


export const AuthProvider = (props: AuthProviderProps): ReactElement => {
  const { authService, children } = props

    let roles = authService.getAuthUser()?.roles
    let isStaff = !roles?.includes('Player');

  return (    
      <AuthContext.Provider value={{ authService, isStaff }}>
      {children}
    </AuthContext.Provider>
  )
}
